import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppPreloadingStrategy } from './app-routing.loader';
import { productRoutes } from './product.routes';

const routes: Routes = [];
productRoutes.forEach(r => routes.push(r));

// routes.push({
//   path: '**',
//   redirectTo: 'page-not-found'
// });

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: AppPreloadingStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {
    console.log('AppRoutingModule loaded.');
    console.log('all routes: ', routes);
  }
}
